import React from "react";
import Nav from "./Nav";
import Footer from "./Footer";
import FAQs from "./FAQs";

const FAQsPage = () => {
  return (
    <div>
      <Nav />
      <div className="pb-24">
        <FAQs heading="FAQs" />
      </div>
      <Footer />
    </div>
  );
};

export default FAQsPage;
